import { memo } from 'react'
import { Skeleton } from '../../../shared/ui/Skeleton'

export const PostSkeleton = memo(function PostSkeleton() {
  return (
    <div className="rounded-xl border border-border bg-card p-6 shadow-sm">
      <header className="mb-4 flex items-start gap-4">
        <Skeleton className="h-10 w-10 rounded-full" />
        <div className="flex-1">
          <div className="mb-2 flex items-center gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="ml-auto h-4 w-12" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-5 w-16 rounded-xl" />
            <Skeleton className="h-5 w-16 rounded-xl" />
          </div>
        </div>
      </header>

      <div className="mb-4 space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-[90%]" />
        <Skeleton className="h-4 w-[85%]" />
      </div>

      <div className="flex items-center gap-6 border-t border-border pt-4">
        <Skeleton className="h-8 w-12 rounded-lg" />
        <Skeleton className="h-8 w-12 rounded-lg" />
        <Skeleton className="h-8 w-12 rounded-lg" />
        <Skeleton className="h-8 w-12 rounded-lg" />
      </div>
    </div>
  )
})
